import(/* webpackMode: "eager" */ "/vercel/path0/web/app/auth/page.tsx");
